import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export interface ReturnOrdersState {
    byOrderId: {
        [orderNumber: string]: {
            isLoading: boolean;
            data: OrderModel[];
        };
    };
}

const initialState: ReturnOrdersState = {
    byOrderId: {},
};

const reducer = {
    "Custom/OrderDetails/BeginLoadOrder": (draft: Draft<ReturnOrdersState>, action: { orderNumber: string }) => {
        if (!draft.byOrderId[action.orderNumber]) {
            draft.byOrderId[action.orderNumber] = { isLoading: true, data: [] };
        } else {
            draft.byOrderId[action.orderNumber].isLoading = true;
        }
    },

    "Custom/OrderDetails/ReturnOrdersLoaded": (
        draft: Draft<ReturnOrdersState>,
        action: { orderNumber: string; result: OrderModel[] },
    ) => {
        draft.byOrderId[action.orderNumber] = {
            isLoading: false,
            data: action.result || [],
        };
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
